export default __webpack_public_path__ + "static/media/carImage_Green.8441050f.png";